'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectFilter = require('./objectFilter');

var _objectFilter2 = _interopRequireDefault(_objectFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {Object} object - object to run filters on
 * @param {String|String[]} filters - property name or names to exclude
 */
var omit = function omit(object) {
  for (var _len = arguments.length, filters = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    filters[_key - 1] = arguments[_key];
  }

  return _objectFilter2.default.apply(undefined, [object, false].concat(filters));
};

exports.default = omit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/utils/underscore/omit.js
// module id = 60
// module chunks = 177